import React, { useEffect, useState } from 'react';
import { useAuth } from '@/components/auth/AuthProvider';
import { apiClient } from '@/services/api';

export function Navbar() {
  const { user, logout, authService, isLoading } = useAuth();
  const [serverStatus, setServerStatus] = useState<'online' | 'offline'>('offline');

  useEffect(() => {
    // Don't start checking server status until auth is ready
    if (isLoading || !authService) {
      return;
    }

    const checkServerStatus = async () => {
      try {
        await apiClient.get('/eval/api/auth/config');
        setServerStatus('online');
      } catch {
        setServerStatus('offline');
      }
    };

    checkServerStatus();
    const interval = setInterval(checkServerStatus, 5000);
    return () => clearInterval(interval);
  }, [isLoading, authService]); // Depend on auth readiness

  return (
    <nav className="bg-blue-700 text-white shadow-lg">
      <div className="px-6 py-4">
        <div className="flex items-center justify-between">
          <h1 className="text-xl font-bold">Agent Evaluation UI</h1>
          
          <div className="flex items-center space-x-4 text-sm">
            <span className="font-medium">{user?.email}</span>
            
            <button
              onClick={logout}
              className="px-3 py-1 bg-white bg-opacity-20 rounded border border-white border-opacity-30 hover:bg-opacity-30 transition-colors"
            >
              Logout
            </button>
            
            <div className="flex items-center space-x-2">
              <span 
                className={`w-2 h-2 rounded-full ${
                  serverStatus === 'online' ? 'bg-green-400' : 'bg-red-400'
                } animate-pulse`}
              />
              <span>{serverStatus}</span>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
}